import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { FacadeService } from "src/app/shared/service-facade/facade.service";

@Injectable({
  providedIn: "root"
})
export class NewSessionResolver implements Resolve<boolean> {
  constructor(
    private facade: FacadeService
  ) {}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((res, rej) => {
      // Clear out the local storage - clean house
      this.facade.clearStorage();

      // Create new session ID
      this.facade.createNewSession(route, () => {
        res(true);
      });
    });
  }
}
